import { render } from "./AppCard.vue?vue&type=template&id=02b8b940&scoped=true"
const script = {}

import "./AppCard.vue?vue&type=style&index=0&id=02b8b940&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b8b940"]])

export default __exports__